import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import {
  Box,
  Paper,
  TextField,
  Button,
  MenuItem,
  IconButton,
} from "@mui/material";


import styles from "../../Dashboard.module.css";
import { countries } from "../../../../utils/country";
import { useNotificationContext } from "../../../../contextProviders/NotificationProvider";
import { useClientsApi } from "../../../../hooks/useClientsApi";
import { useConsumerApi } from "../../../../hooks/useConsumerApi";
import EditIcon from "@mui/icons-material/Edit";

const ConsumerSearchComponent = ({ onViewClick }) => {
  const { loading: clientLoading, clients, fetchClients } = useClientsApi();
  const { searchConsumers } = useConsumerApi();
  const { showNotification } = useNotificationContext();
  const [consumersBySearch, setConsumersBySearch] = useState([]);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    name: "",
    clientid: "All",
    dateOfMessage: "",
    email: "",
    telephone: "",
    address: "",
    postcode: "",
    country: "All",
    dob: "",
  });

  const [phoneCode, setPhoneCode] = useState(
    countries.find((c) => c.code === formData.country)?.phoneCode || ""
  );

  useEffect(() => {
    const selected = countries.find((c) => c.code === formData.country);
    setPhoneCode(selected ? selected.phoneCode : "");
  }, [formData.country]);
const { updateConsumer } = useConsumerApi();
const [rows, setRows] = useState(consumersBySearch);



  // Define columns
  const columns = [
    { field: "id", headerName: "id", width: 70, hide: true },
    { field: "clientName", headerName: "Client", width: 200 },
    { field: "consumerName", headerName: "Consumer", width: 250},
    {
      field: "action",
      headerName: "Edit",
      width: 140,
      sortable: false,
      renderCell: (params) => (
        <IconButton
          onClick={() => onViewClick(params.row)}
          sx={{
            color: "var(--color-icon)",
            "&:hover": {
              backgroundColor: "rgba(25, 118, 210, 0.1)",
            },
          }}
        >
          <EditIcon />
        </IconButton>
      ),
    },
  ];

  const handleDetailsChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    if (errors[field]) {
      setErrors((prev) => ({ ...prev, [field]: undefined }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = formatConsumerPayload(formData);
      let result = await searchConsumers(payload);

      if (result.length === 0) {
        showNotification("No records found", "info");
      }
      setConsumersBySearch(result || result.data || []);
    } catch (error) {
      console.error("Search failed:", error);
    }
  };

  const formatConsumerPayload = (formData) => ({
    Name: formData.name || "",
    ClientId: parseInt(formData.clientid) || null,
    Email: formData.email || "",
    Telephone: phoneCode + formData.telephone || "",
    Address: formData.address || "",
    PostCode: formData.postcode || "",
    Country: formData.country == "All" ? "" : formData.country || "",
    DateOfBirth: formData.dob ? new Date(formData.dob) : null,
    CreatedAt: formData.dateOfMessage ? new Date(formData.dateOfMessage) : null,
  });

  useEffect(() => {
    fetchClients();
  }, []);

  return (
    <div style={{ padding: "20px", maxWidth: "1200px", margin: "0 auto" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: 30,
          flexWrap: "wrap",
          gap: 12,
        }}
      >
        <h1 className={styles.dashboardTitle}>CONSUMER SEARCH</h1>
      </div>

      <Box
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: 20,
          marginBottom: 20,
          width: "100%",
        }}
      >
        <TextField
          type="text"
          label="Name"
          autoFocus = {true}
       
          name="name"
          value={formData.name}
          onChange={(e) => handleDetailsChange("name", e.target.value)}
          size="medium"
          inputProps={{ maxLength: 30 }}
          sx={{
            width: "30%",
            minWidth: 180,
          
          }}
        />

        <TextField
          select
          label="Client"
          name="clientid"
          value={formData.clientid}
          onChange={(e) => handleDetailsChange("clientid", e.target.value)}
          size="medium"
          sx={{
            width: "30%",
            minWidth: 180,
          }}
          disabled={clientLoading}
          SelectProps={{
            MenuProps: {
              MenuListProps: {
                sx: {
                  maxHeight: 250, // Set your desired max height here
                  overflowY: "auto", // Enable vertical scrolling
                },
              },
            },
          }}
        >
          <MenuItem value="All" selected>
            All Client
          </MenuItem>
          {clients.map((client) => (
            <MenuItem key={client.id} value={client.id.toString()}>
              {client.name}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          type="date"
          label="Date of Message"
          name="dateOfMessage"
          value={formData.dateOfMessage}
          onChange={(e) => handleDetailsChange("dateOfMessage", e.target.value)}
          size="medium"
          inputProps={{
            maxLength: 30,
            max: new Date().toISOString().split("T")[0],
          }}
          InputLabelProps={{ shrink: true }}
          sx={{
            width: "30%",
            minWidth: 180,
          }}
        />

        <TextField
          type="email"
          label="Email"
          name="email"
          value={formData.email}
          onChange={(e) => handleDetailsChange("email", e.target.value)}
          size="medium"
          inputProps={{ maxLength: 50 }}
          sx={{
            width: "30%",
            minWidth: 180,
          }}
        />

        <TextField
          label="Telephone"
          name="telephone"
          value={formData.telephone}
          onChange={(e) =>
            handleDetailsChange(
              "telephone",
              e.target.value.replace(/[^0-9]/g, "")
            )
          }
          sx={{
            width: "30%",
            minWidth: 180,
          }}
          inputProps={{ maxLength: 15 }}
          InputProps={{
            startAdornment: (
              <Box
                sx={{
                  minWidth: 72,
                  mr: 1,
                  borderRight: "2px solid #E9E9E9",
                  pr: 1,
                }}
              >
                {phoneCode}
              </Box>
            ),
          }}
        />

        <TextField
          type="text"
          label="Address"
          name="address"
          value={formData.address}
          onChange={(e) => handleDetailsChange("address", e.target.value)}
          size="medium"
          inputProps={{
            maxLength: 30,
            max: new Date().toISOString().split("T")[0],
          }}
          sx={{
            width: "30%",
            minWidth: 180,
          }}
        />
      </Box>

      <Box
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: 20,
          marginBottom: 20,
          width: "100%",
        }}
      >
        <TextField
          label="Postcode"
          name="postcode"
          value={formData.postcode}
          onChange={(e) =>
            handleDetailsChange(
              "postcode",
              e.target.value.replace(/[^0-9]/g, "")
            )
          }
          size="medium"
          inputProps={{ maxLength: 6, pattern: "[0-9]*" }}
          sx={{
            width: "30%",
            minWidth: 180,
          }}
        />

        <TextField
          select
          label="Country"
          name="country"
          value={formData.country}
          onChange={(e) => handleDetailsChange("country", e.target.value)}
          size="medium"
          sx={{
            width: "30%",
            minWidth: 180,
          }}
          SelectProps={{
            MenuProps: {
              PaperProps: {
                style: {
                  maxHeight: 220, // Set your desired max height here
                },
              },
            },
          }}
          disabled={clientLoading}
        >
          <MenuItem value="All" selected>
            All Country
          </MenuItem>
          {countries.map((country) => (
            <MenuItem key={country.code} value={country.code}>
              {country.name}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          type="date"
          label="Date of Birth"
          name="dob"
          value={formData.dob}
          onChange={(e) => handleDetailsChange("dob", e.target.value)}
          size="medium"
          inputProps={{
            maxLength: 30,
            max: new Date().toISOString().split("T")[0],
          }}
          InputLabelProps={{ shrink: true }}
          sx={{
            width: "30%",
            minWidth: 180,
          }}
        />
      </Box>
      <Box
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: 20,
          marginBottom: 20,
          width: "100%",
        }}
      >
        <Box sx={{ height: 40, width: "30%", minWidth: 180 }} />
        <Box sx={{ height: 40, width: "30%", minWidth: 180 }} />
        <Button
          type="submit"
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          sx={{ height: 40, width: "30%", minWidth: 180 }}
        >
          Search
        </Button>
      </Box>
      {consumersBySearch.length > 0 && (
        <Paper

          sx={{ height: 470, width: "100%", borderRadius: 2, boxShadow: 2 ,cursor: 'pointer'  }}
        >
          <DataGrid
            rows={consumersBySearch}
            columns={columns}
            rowHeight={36}

             onRowDoubleClick={(params) => onViewClick(params.row)}
            initialState={{
              columns: {
                columnVisibilityModel: {
                  id: false, 
                },
              },
              pagination: { paginationModel: { pageSize: 10, page: 0 } },
            }}
            pageSizeOptions={[10, 20, 50]}
            disableRowSelectionOnClick
            sx={{
              border: 0,
              "& .MuiDataGrid-columnHeaderTitle": {
                fontSize: "14px",
                fontWeight: "bold",
              },
            }}
          />
        </Paper>
      )}
    </div>
  );
};
export default ConsumerSearchComponent;
